import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['container'];
  static values = { url: String };

  connect() {
    this.mapInstance = null;
    this.initialized = false;

    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !this.initialized) {
        this.initialized = true;
        this.initializeMap();
      }
    });
    this.observer.observe(this.element);

    this.filterHandler = (event) => {
      if (this.mapInstance && this.mapInstance.applyFilters) {
        this.mapInstance.applyFilters(event.detail.filters);
      }
    };
    document.addEventListener('icp-universe:filters-changed', this.filterHandler);

    this.orgSelectHandler = (event) => {
      if (this.mapInstance && this.mapInstance.selectOrg) {
        this.mapInstance.selectOrg(event.detail.orgId);
      }
    };
    document.addEventListener('icp-universe:org-selected', this.orgSelectHandler);

    this.sidebarClosedHandler = () => {
      if (this.mapInstance && this.mapInstance.resize) {
        setTimeout(() => this.mapInstance.resize(), 50);
      }
    };
    document.addEventListener('icp-universe:sidebar-closed', this.sidebarClosedHandler);
  }

  async initializeMap() {
    if (!this.urlValue) return;

    try {
      const module = await import('../pages/icp_universe/map');
      const createMap = module.default;
      const initialFilters = this.getFiltersFromUrl();
      const initialOrgId = this.getUrlParam('org');
      this.mapInstance = createMap(this.containerTarget, this.urlValue, initialFilters, initialOrgId);
    } catch (error) {
      console.error('Failed to load ICP Universe map:', error);
    }
  }

  getFiltersFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return {
      state: params.get('state') || '',
      segment: params.get('segment') || '',
      discipline: params.get('discipline') || '',
      q: params.get('q') || '',
      tier: params.get('tier') || ''
    };
  }

  getUrlParam(key) {
    return new URLSearchParams(window.location.search).get(key) || '';
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
    document.removeEventListener('icp-universe:filters-changed', this.filterHandler);
    document.removeEventListener('icp-universe:org-selected', this.orgSelectHandler);
    document.removeEventListener('icp-universe:sidebar-closed', this.sidebarClosedHandler);
    if (this.mapInstance && this.mapInstance.destroy) {
      this.mapInstance.destroy();
      this.mapInstance = null;
    }
  }
}
